module.exports = __webpack_public_path__ + "static/media/logocrypto.402087cf.svg";